/** ULID-style ids: 48-bit time + 80 random bits, Crockford base32, lexically sortable. */
const ALPHABET = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';

export type RandomSource = (bytes: Uint8Array) => Uint8Array;

const defaultRandom: RandomSource = b => crypto.getRandomValues(b);

export function newId(now: number, random: RandomSource = defaultRandom): string {
  let t = Math.floor(now), time = '';
  for (let i = 0; i < 10; i++) { time = ALPHABET[t % 32] + time; t = Math.floor(t / 32); }
  const r = random(new Uint8Array(16));
  let rand = '';
  for (let i = 0; i < 16; i++) rand += ALPHABET[r[i]! % 32];
  return time + rand;
}
